import script from "./EventPersonalStats.vue?vue&type=script&setup=true&lang=js"
export * from "./EventPersonalStats.vue?vue&type=script&setup=true&lang=js"

const cssModules = {}
import style0 from "./EventPersonalStats.vue?vue&type=style&index=0&id=23eb95dc&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules]])

export default __exports__